<input type="time"  [(ngModel)]="value"  [name]="name" min="00:00" max="23:59">